import { Api } from '@/api/api.client';
import { Components } from '@/api/generated/api';
import { ComputedRef } from 'vue';
import { useToast } from '@/composables/useToast';
import { useCompetenceDomain } from '@/composables/useCompetenceDomain';
import { useSchoolSubject } from '../schoolSubject/useSchoolSubject';
interface ISchoolSubjectTemplateComposable {
  allProviderSubjectTemplates: ComputedRef<Components.Schemas.SchoolSubjectDto[]>;
  allCompetenceDomainTemplatesForSubjectTemplate: ComputedRef<Components.Schemas.CompetenceDomainDto[]>;
  createSchoolSubjectProviderTemplate: (dto: Components.Schemas.CreateSchoolSubjectProviderDto) => Promise<void>;
  deleteSchoolSubject: (schoolSubjectId: number) => Promise<void>;
  updateSchoolSubject: (schoolSubjectId: number, dto: Components.Schemas.UpdateSchoolSubjectDto) => Promise<void>;
  createCompetenceDomainProviderTemplate: (
    subjectTemplateId: number,
    dto: Components.Schemas.CreateCompetenceDomainDto,
  ) => Promise<void>;
  refresh: () => Promise<void>;
}

export const useProviderSubjectTemplates = (): ISchoolSubjectTemplateComposable => {
  const { createSuccessToast, catchError } = useToast();
  const {
    deleteSchoolSubject: deleteSchoolSubjectExternal,
    updateSchoolSubject: updateSchoolSubjectExternal,
    allSchoolSubjectTemplates: allProviderSubjectTemplates,
    refresh,
  } = useSchoolSubject();
  const { allCompetenceDomainTemplatesForSubjectTemplate, refresh: refreshCompetenceDomains } = useCompetenceDomain();

  const createSchoolSubjectProviderTemplate = async (
    dto: Components.Schemas.CreateSchoolSubjectProviderDto,
  ): Promise<void> => {
    await catchError(async () => {
      await Api.Routes.SchoolSubjectProvider.createSubjectTemplate({}, dto);
      await refresh();
      createSuccessToast();
    });
  };

  const deleteSchoolSubject = async (schoolSubjectId: number): Promise<void> => {
    await deleteSchoolSubjectExternal(schoolSubjectId);
    await refresh();
  };

  const updateSchoolSubject = async (
    schoolSubjectId: number,
    dto: Components.Schemas.UpdateSchoolSubjectDto,
  ): Promise<void> => {
    await updateSchoolSubjectExternal(schoolSubjectId, dto);
    await refresh();
  };

  const createCompetenceDomainProviderTemplate = async (
    subjectTemplateId: number,
    dto: Components.Schemas.CreateCompetenceDomainDto,
  ): Promise<void> => {
    await catchError(async () => {
      await Api.Routes.SchoolSubjectProvider.createCompetenceDomainTemplate(
        { schoolSubjectId: subjectTemplateId },
        dto,
      );
      await refreshCompetenceDomains();
      createSuccessToast();
    });
  };

  return {
    allProviderSubjectTemplates,
    allCompetenceDomainTemplatesForSubjectTemplate,
    deleteSchoolSubject,
    updateSchoolSubject,
    createSchoolSubjectProviderTemplate,
    createCompetenceDomainProviderTemplate,
    refresh,
  };
};
